import { render, staticRenderFns } from "./TextRow.vue?vue&type=template&id=19c6e6d1&"
import script from "./TextRow.vue?vue&type=script&lang=js&"
export * from "./TextRow.vue?vue&type=script&lang=js&"
import style0 from "./TextRow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports